import axios from "axios";
import type { AirlineScore } from "services/scores";
import type { OptionValue, SelectDateProps } from "../types";

export const getBySeason = async (season: OptionValue, scoresType: SelectDateProps["scoresType"]) => {
  try {
    const { data } = await axios.get<AirlineScore[]>(`/api/scores/get-${scoresType}-by-season?season=${season}`);

    return data;
  } catch (error) {
    throw Error(error);
  }
};
